var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsrLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 62.7 67.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 21.54,
    y1: 34.28,
    x2: 62.7,
    y2: 34.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#88194e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#951f4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#c7373b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#c7353c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c52e40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#c22347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1351"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 24.53,
    y1: 48.28,
    x2: 0,
    y2: 48.28,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 9.22,
    y1: 66.96,
    x2: 24.06,
    y2: 2.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ec6408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbba00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f69618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f06539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#eb4251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#e82c60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#e72465"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.27 10.61s11.67 6.75 15.66 9.11a70.94 70.94 0 018.82 5.85 9.55 9.55 0 014 7.55c0 3.78-2 5.88-4 7.46-1.19 1-7.23 4.32-7.23 4.32C48 46.81 31.39 56 31.39 56l-5.25 3 .36.1.39-1 1.8-18.83s3.88-2.08 5-2.64a18.27 18.27 0 003.59-2.3 2.93 2.93 0 00.61-3.65c-.78-1.41-6.56-4.68-6.56-4.68l-5.51-3.3s-5.21-6.53-4.14-9.7c1-3 4.8-3.42 5.76-3.51 2.84-.31 6.83 1.12 6.83 1.12z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.63 30.29s2.79 12.39-4 18.33C.68 53.76-1.28 57.6.82 62.18c2.85 6.23 11.89 3.69 14.81 3s8.9-16.76 8.9-16.76L14.45 31.86z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.58 67.09a33.27 33.27 0 01-9-.74 10.22 10.22 0 01-3.07-1.18 5.7 5.7 0 002 0c1.56-.22 8.11-1.8 12.35-9.24s-1.49-15.27-2.69-17.1c-1.46-2.22-6.47-10-8.48-13.24a65.76 65.76 0 01-5.1-10.15C.88 13-1.07 7.21 4.23 2.43s13.49-.9 13.49-.9C19.67 2.29 28.35 7 28.35 7a11.15 11.15 0 00-2.11-.18s-7 0-8 4.61 5.5 13.77 5.5 13.77c2 3.07 4.33 6.1 5.79 9.09 0 0 6.08 10.26 5.09 17.28A16.41 16.41 0 0126.75 64c-4.35 2.85-11.17 3.09-11.17 3.09z",
    fill: "url(#c)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsrLogo);
export default __webpack_public_path__ + "static/media/msr-logo.e53b5b6685bfdccdc4242e27f25a7d9e.svg";
export { ForwardRef as ReactComponent };